/**
 * レスポンシブデザイン用ブレイクポイント設定
 * 2段階構成：モバイル（スマホ）とデスクトップ（タブレット・PC）
 */

/**
 * ブレイクポイントの閾値
 */
export const BREAKPOINTS = {
  /** モバイルの最大幅（これ以下がモバイル） */
  mobile: 767,
  /** デスクトップの最小幅（これ以上がデスクトップ） */
  desktop: 768,
} as const;

/**
 * デバイスタイプ判定用のメディアクエリ
 */
export const MEDIA_QUERIES = {
  mobile: `(max-width: ${BREAKPOINTS.mobile}px)`,
  desktop: `(min-width: ${BREAKPOINTS.desktop}px)`,
} as const;

/**
 * Ant Design Grid用の共通設定
 */
export const GRID_CONFIG = {
  /** 統計カード用 */
  statsCard: {
    mobile: { xs: 12 },           // モバイル: 2カラム（2×2グリッド）
    desktop: { xs: 24, sm: 12, lg: 6 }, // デスクトップ: 4カラム
  },
  /** コンテンツセクション用 */
  contentSection: {
    mobile: { xs: 24 },           // モバイル: 全幅
    desktop: { xs: 24, lg: 12 },  // デスクトップ: 2カラム
  },
  /** 詳細ビュー用 */
  detailView: {
    mobile: { xs: 24 },           // モバイル: 全幅
    desktop: { xs: 24, md: 12 },  // デスクトップ: 2カラム
  },
} as const;

/**
 * レスポンシブ用の共通スタイル設定
 */
export const RESPONSIVE_STYLES = {
  /** ガター（要素間の間隔） */
  gutter: {
    mobile: [8, 8] as [number, number],
    desktop: [16, 16] as [number, number],
  },
  /** パディング */
  padding: {
    mobile: 12,
    desktop: 24,
  },
  /** カードの最小高さ */
  cardMinHeight: {
    mobile: 'auto',
    desktop: '150px',
  },
} as const;

/**
 * デバイスタイプを判定するユーティリティ型
 */
export type DeviceType = 'mobile' | 'desktop';

/**
 * 現在のデバイスタイプを判定
 */
export const getDeviceType = (width: number): DeviceType => {
  return width <= BREAKPOINTS.mobile ? 'mobile' : 'desktop';
};

/**
 * レスポンシブな値を返すヘルパー関数
 */
export const getResponsiveValue = <T>(
  width: number,
  mobileValue: T,
  desktopValue: T
): T => {
  return getDeviceType(width) === 'mobile' ? mobileValue : desktopValue;
};